/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'

import Card from 'react-bootstrap/Card'
import moment from 'moment'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import SearchIcon from '@material-ui/icons/Search';

import XLSX from "xlsx";
import Swal from 'sweetalert2'
// import BeaconContent from './BeaconContent'
import axios from 'axios';
import InputGroup from 'react-bootstrap/InputGroup'
import { Col, FormControl, Row, ListGroup, Media } from 'react-bootstrap';
// import Select from 'react-select';
// import { DateTime } from './share';
import { history } from '../router/route';

const Location = (props) => {
    const d = new Date();
    const startDate = new Date();
    const [logs, setLogs] = useState([])
    const [temps, setTemps] = useState([])
    // const [beacons, setBeacons] = useState([])
    const [beaconsTemp, setBeaconsTemp] = useState([{ value: null, label: 'All' }])
    const [selectTemp, setSelectTemp] = useState({ value: null, label: 'All' })
    // const [beacon, setBeacon] = useState(null)
    const [dateRange, setDateRange] = useState([new Date(startDate.setDate(d.getDate() - 0)), d]);
    // const [excel_data, setExcelData] = useState([])


    // useEffect(() => {
    //   let isMounted = true; // note this mounted flag
    //   requestChartUsage();
    //   // convertData()
    //   return () => {
    //     isMounted = false;
    //   };

    // }, []);

    useEffect(() => {
        requestBeacons()
    }, [props])

    async function requestBeacons() {
        const params = {
            "work": "BEACON.LIST",
            "item_per_request": 100,
            "current_item_amount": 0
        }
        const res = await axios.post(`${process.env.REACT_APP_BEV_API}/v3/apis/beacon`, params, {
            auth: {
                username: process.env.REACT_APP_USERNAME,
                password: process.env.REACT_APP_PASSWORD
            }
        });
        if (res.data.status === true) {
            // setBeacons(res.data.result)
            var bTemps = []
            bTemps.push({ value: null, label: 'All' })
            res.data.result.forEach(element => {
                bTemps.push({ value: element.rxid, label: element.code_name })
            });
            setBeaconsTemp(bTemps)
            if (selectTemp === null) {
                setSelectTemp(bTemps(0))
                requestBeaconLogs(bTemps(0).value)
            } else {
                requestBeaconLogs(selectTemp.value)
            }

        }
    }
    async function requestBeaconLogs(rxid) {
        // var beforeDate = moment().add(-1, 'M');
        var finish = false
        var itemCount = 0
        var temp = []
        Swal.fire({
            html: 'กำลังโหลดข้อมูล <b></b>%',
            // timer: 2000,
            timerProgressBar: true,
            allowOutsideClick: false
        })
        Swal.isVisible()
        Swal.showLoading()
        do {
            const params = {
                "work": "BEACON_LOG.GET_BY_RXID",
                "item_per_request": 50000,
                "current_item_amount": itemCount,
                "rxid": rxid,
                "start": {
                    "date": parseInt(moment(dateRange[0]).format("DD")),
                    "month": parseInt(moment(dateRange[0]).format("MM")),
                    "year": parseInt(moment(dateRange[0]).format("YYYY")),
                    "hour": 0,
                    "minute": 0
                },
                "end": {
                    "date": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("DD") : new Date().getDay()),
                    "month": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("MM") : new Date().getMonth()),
                    "year": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("YYYY") : new Date().getFullYear()),
                    "hour": 23,
                    "minute": 59
                }
            }

            const res = await axios.post(`${process.env.REACT_APP_BEV_API}/v3/apis/beacon`, params, {
                auth: {
                    username: process.env.REACT_APP_USERNAME,
                    password: process.env.REACT_APP_PASSWORD
                }
            });
            if (res.data.status === true) {
                if (res.data.result.length > 0) {
                    temp.push(...res.data.result)
                    itemCount += res.data.result.length
                } else {
                    finish = true
                }
            } else {
                finish = true
            }
        } while (!finish)
        setLogs(temp)
        setTemps(temp)
        Swal.close()
    }

    async function requestLogs(value) {
        // var beforeDate = moment().add(-1, 'M');
        var finish = false
        var itemCount = 0
        var temp = []
        Swal.fire({
            html: 'กำลังโหลดข้อมูล <b></b>%',
            // timer: 2000,
            timerProgressBar: true,
            allowOutsideClick: false
        })
        Swal.isVisible()
        Swal.showLoading()
        do {
            const params = {
                "work": "BEACON_LOG.GET_BY_RXID",
                "item_per_request": 50000,
                "current_item_amount": itemCount,
                "rxid": selectTemp.value,
                "start": {
                    "date": parseInt(moment(value[0]).format("DD")),
                    "month": parseInt(moment(value[0]).format("MM")),
                    "year": parseInt(moment(value[0]).format("YYYY")),
                    "hour": 0,
                    "minute": 0
                },
                "end": {
                    "date": parseInt((value[1] !== null) ? moment(value[1]).format("DD") : new Date().getDay()),
                    "month": parseInt((value[1] !== null) ? moment(value[1]).format("MM") : new Date().getMonth()),
                    "year": parseInt((value[1] !== null) ? moment(value[1]).format("YYYY") : new Date().getFullYear()),
                    "hour": 23,
                    "minute": 59
                }
            }

            const res = await axios.post(`${process.env.REACT_APP_BEV_API}/v3/apis/beacon`, params, {
                auth: {
                    username: process.env.REACT_APP_USERNAME,
                    password: process.env.REACT_APP_PASSWORD
                }
            });
            if (res.data.status === true) {
                if (res.data.result.length > 0) {
                    temp.push(...res.data.result)
                    itemCount += res.data.result.length
                } else {
                    finish = true
                }
            } else {
                finish = true
            }
        } while (!finish)
        setLogs(temp)
        setTemps(temp)
        Swal.close()
    }


    // const time = (t)=>{
    //   if (t>60){
    //     return `${Math.floor(Math.floor(t)/60)} นาที ${Math.floor(t)%60} วินาที`
    //   }else{
    //     return `${Math.floor(t)} วินาที`
    //   }

    // }

    const loadData = () => {
        let tempex = []
        logs.map((row, i) => {
            // if(i===0){
            //   tempex.push(["คลาสหน้าจอ","จำนวนครั้ง","จำนวนคน","เวลาเฉลี่ย"]);
            // }
            var obj = { "วัน": `${moment(row._cd).utc().format('DD/MM/YYYY')}`, "เวลา": `${moment(row._cd).utc().format('HH:mm:ss')}`, "beacon_id": `${row.beacon.minor_id}`, "ชื่อสถานที่": `${row.beacon.code_name}`, "รหัสพนักงาน": `${row.emp_id}`, "ชื่อ": `${row.person.first_name}`, "นามสกุล": `${row.person.last_name}`, "ละติจูด": `${row.location.latitude}`, "ลองติจูด": `${row.location.longitude}`, "ระยะ": `${row.meter}`, "รุ่นโทรศัพท์": row.device ? `${row.device ? row.device.brand : ''}, ${row.device ? row.device.model : ''}` : '-' }
            tempex.push(obj);
        })

        const ws = XLSX.utils.json_to_sheet(tempex);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, selectTemp.code_name);
        /* generate XLSX file and send to client */
        XLSX.writeFile(wb, `Beacon Log_${moment().format("DDMMYYYY-HH:mm:ss")}.xlsx`);
    }

    const searchEmp = (emp) => {
        var result = temps.filter(function (el) {
            return el.emp_id.indexOf(emp) !== -1
        });
        setTemps(result)
    }

    const onSelectChange = value => {
        // this.toggleOpen();
        setSelectTemp(value) || requestBeaconLogs(value.value)
    }

    const onSelectDate = value => {
        setDateRange(value)
        if (value[1] !== null) {
            requestLogs(value)
        }

    }

    function onClickToDetail() {
        history.push('/zone')
    }

    return (
        <>
            <Card className='border-0'>
                <Card.Header className="bg-white">
                    <Row>
                        <Col>
                            <Card.Title className="py-2 mb-0">Location Detail</Card.Title>
                        </Col>
                        <Col>
                            <div className="float-right">
                                {/* <InputGroup className="float-right bg-white" style={{ width: 320 }}> */}
                                <InputGroup.Prepend className='position-absolute'>
                                    <InputGroup.Text id="basic-addon1" className="bg-white border-0 bg-transparent mt-1">
                                        <SearchIcon></SearchIcon>
                                    </InputGroup.Text>
                                </InputGroup.Prepend>
                                <FormControl
                                    aria-label="search"
                                    aria-describedby="basic-addon1"
                                    // className="pl-5"
                                    type="text"
                                    placeholder="ค้นหา"
                                    style={{ width: 320, paddingLeft: '2.5rem' }}
                                    onChange={(e) => searchEmp(e.target.value)}
                                />
                                {/* </InputGroup> */}
                            </div>
                            {/* <Form.Control style={{ width: 320 }} className="float-right" type="text" placeholder="รหัสพนักงาน" onChange={(e) => searchEmp(e.target.value)} /> */}
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>

                    <div className="d-flex bd-highlight">
                        <div className="p-2 flex-fill bd-highlight">
                            <Media className="d-flex align-items-center">
                                <Media.Body >
                                    <h6 className="mb-1">ตึกแสงโสม</h6>
                                    <p className="mb-0">
                                        119/2 Moo.7, Wangban, Lomkao, Phetchabun, 67120
                                    </p>
                                </Media.Body>
                            </Media>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <Media className="d-flex align-items-center">
                                <Media.Body className="justify-content-center">
                                    <h6 className="font-weight-light mb-1 text-uppercase">ZONE</h6>
                                    <h4 className="mb-0">
                                        12
                                    </h4>
                                </Media.Body>
                            </Media>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <Media className="d-flex align-items-center">
                                <Media.Body className="justify-content-center">
                                    <h6 className="font-weight-light mb-1 text-uppercase">beacons</h6>
                                    <h4 className="mb-0">
                                        65
                                    </h4>
                                </Media.Body>
                            </Media>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <Media className="d-flex align-items-center">
                                <Media.Body className="justify-content-center">
                                    <h6 className="font-weight-light mb-1 text-uppercase">ละติจูด</h6>
                                    <h5 className="mb-0 font-weight-light">
                                        13.844700123845
                                    </h5>
                                </Media.Body>
                            </Media>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <Media className="d-flex align-items-center">
                                <Media.Body className="justify-content-center">
                                    <h6 className="font-weight-light mb-1 text-uppercase">ลองติจูด</h6>
                                    <h5 className="mb-0 font-weight-light">
                                        100.596958545253
                                    </h5>
                                </Media.Body>
                            </Media>
                        </div>
                    </div>
                    <div className="p-3 bg-light text-dark">
                        <Row>
                            <Col>
                                <Media className="d-flex align-items-center">
                                    <Media.Body >
                                        <h6 className="font-weight-normal mb-1 text-uppercase">ZONES</h6>

                                    </Media.Body>
                                </Media>
                            </Col>
                            <Col className="d-flex align-items-center">
                                <h6 className="font-weight-normal mb-1 text-uppercase">Beacons</h6>
                            </Col>
                            <Col className="d-flex align-items-center justify-content-end">
                                {/* <ArrowForwardIosIcon color='primary'></ArrowForwardIosIcon> */}
                            </Col>
                        </Row>
                    </div>
                    <ListGroup>
                        <ListGroup.Item action onClick={onClickToDetail}>
                            <Row>
                                <Col>
                                    <Media className="d-flex align-items-center">
                                        <Media.Body >
                                            <h6 className="mb-1">ZONE A</h6>
                                        </Media.Body>
                                    </Media>
                                </Col>
                                <Col className="d-flex align-items-center">
                                    <h6 className="mb-1">25</h6>
                                </Col>
                                <Col className="d-flex align-items-center justify-content-end">
                                    <ArrowForwardIosIcon color='primary'></ArrowForwardIosIcon>
                                </Col>
                            </Row>
                        </ListGroup.Item>
                        <ListGroup.Item action>
                            <Row>
                                <Col>
                                    <Media className="d-flex align-items-center">
                                        <Media.Body >
                                            <h6 className="mb-1">ZONE A</h6>
                                        </Media.Body>
                                    </Media>
                                </Col>
                                <Col className="d-flex align-items-center">
                                    <h6 className="mb-1">25</h6>
                                </Col>
                                <Col className="d-flex align-items-center justify-content-end">
                                    <ArrowForwardIosIcon color='primary'></ArrowForwardIosIcon>
                                </Col>
                            </Row>
                        </ListGroup.Item>
                        <ListGroup.Item action>
                            <Row>
                                <Col>
                                    <Media className="d-flex align-items-center">
                                        <Media.Body >
                                            <h6 className="mb-1">ZONE A</h6>
                                        </Media.Body>
                                    </Media>
                                </Col>
                                <Col className="d-flex align-items-center">
                                    <h6 className="mb-1">25</h6>
                                </Col>
                                <Col className="d-flex align-items-center justify-content-end">
                                    <ArrowForwardIosIcon color='primary'></ArrowForwardIosIcon>
                                </Col>
                            </Row>
                        </ListGroup.Item>
                    </ListGroup>

                    {/* <BeaconContent data={temps} /> */}
                </Card.Body>
            </Card>
        </>
    )

}

export default Location